module.exports = __webpack_public_path__ + "img/upc-scan.6a8df237.svg";